<div class="mt-2 table-container">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

        <!-- Checkbox Column -->
        <!-- <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? toggleAllRows() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
            </td>
        </ng-container> -->
        <!-- Checkbox Column close -->

        <ng-container matColumnDef="date">
            <th translate mat-header-cell *matHeaderCellDef> Date </th>
            <td mat-cell *matCellDef="let element">  {{ element.date | date: 'dd-MM-yyyy' }} </td>
        </ng-container>

        <ng-container matColumnDef="holiday_name">
            <th translate mat-header-cell *matHeaderCellDef> Festival </th>
            <td mat-cell *matCellDef="let element"> {{element.holiday_name}} </td>
        </ng-container>

        <ng-container matColumnDef="holiday_type">
            <th translate mat-header-cell *matHeaderCellDef> Holiday Type </th>
            <td mat-cell *matCellDef="let element"> {{element.holiday_type}} </td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th translate mat-header-cell *matHeaderCellDef> Description </th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns ; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)">
        </tr>
        <tr class="mat-row" *matNoDataRow>
            <td translate class="mat-cell" colspan="4">No data</td>
        </tr>
    </table>
</div>
<div class="mt-2" *ngIf="total_count > 5">
    <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
</div>